import { render, staticRenderFns } from "./number.vue?vue&type=template&id=253433ba&scoped=true"
import script from "./number.vue?vue&type=script&lang=js"
export * from "./number.vue?vue&type=script&lang=js"
import style0 from "./number.vue?vue&type=style&index=0&id=253433ba&prod&lang=css"
import style1 from "./number.vue?vue&type=style&index=1&id=253433ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253433ba",
  null
  
)

export default component.exports